// Accurafil LCC Calculator - Professional PDF Generator (Revised)

function generateLCCPDF(accurafil, competitors, systemParams, pieChartImage, comparisonChartImage) {
  // Create a new window for the print-friendly report
  const printWindow = window.open('', '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes');
  if (!printWindow) {
    alert('Please allow pop-ups to generate the PDF report.');
    return;
  }
  
  printWindow.document.title = 'AccuraFil LCC Analysis Report';
  
  // Helper functions for formatting data
  const formatCurrency = (value) => value ? '$' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '$0.00';
  const formatNumber = (value, decimals = 2) => value != null ? value.toFixed(decimals) : '0.00';
  
  const today = new Date();
  const dateString = today.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  
  // --- Savings Calculation ---
  let lowestCostCompetitor = null;
  let lowestCompetitorCost = Infinity;
  let savingsAmount = 0;
  let savingsPercent = 0;
  
  if (competitors && competitors.length > 0) {
    const validCompetitors = competitors.filter(c => c && typeof c.totalCostPerAHUPerYear === 'number');
    if (validCompetitors.length > 0) {
        lowestCostCompetitor = validCompetitors.reduce((lowest, current) => 
            current.totalCostPerAHUPerYear < lowest.totalCostPerAHUPerYear ? current : lowest
        );
        lowestCompetitorCost = lowestCostCompetitor.totalCostPerAHUPerYear;
    }
    if (lowestCostCompetitor && accurafil && typeof accurafil.totalCostPerAHUPerYear === 'number') {
      savingsAmount = lowestCompetitorCost - accurafil.totalCostPerAHUPerYear;
      if (lowestCompetitorCost > 0) {
        savingsPercent = (savingsAmount / lowestCompetitorCost) * 100;
      }
    }
  }

  // --- HTML and CSS for the Report ---
  const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <title>AccuraFil LCC Analysis Report</title>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        :root {
          --primary-color: #006738;
          --text-dark: #333;
          --text-light: #666;
          --bg-soft: #f8f9fa;
          --border-color: #dee2e6;
        }

        @page {
          size: A4;
          margin: 10; 
        }

        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.4;
          color: var(--text-dark);
          margin: 0;
          background-color: #fff;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .report-container {
            padding: 2cm;
            max-width: 210mm;
            margin: auto;
        }

        /* --- Header & Footer --- */
        .header {
          text-align: center;
          padding-bottom: 10px;
          border-bottom: 3px solid var(--primary-color);
          margin-bottom: 10px;
        }
        .logo { max-width: 200px; margin-bottom: 10px; }
        .header h1 {
          color: var(--primary-color);
          font-size: 20px;
          font-weight: 700;
          margin: 0 0 5px 0;
        }
        .header .subtitle {
          font-size: 16px;
          color: var(--text-light);
          margin: 0;
        }
        .date {
          color: #888;
          font-size: 14px;
          font-style: italic;
        }
         .contact-info {
          text-align: center;
          margin-bottom: 15px;
          padding: 10px;
          background-color: var(--bg-soft);
          border-radius: 8px;
          font-size: 12px;
          color: var(--text-light);
          border: 1px solid var(--border-color);
        }
        .footer {
          position: fixed;
          bottom: 0; left: 0; right: 0;
          padding: 10px 2cm;
          background-color: var(--bg-soft);
          border-top: 1px solid var(--border-color);
          text-align: center;
          font-size: 10px;
          color: var(--text-light);
        }
        .footer a { color: var(--primary-color); text-decoration: none; font-weight: 600; }

        /* --- Layout & Sections --- */
        .section { margin-bottom: 15px; page-break-inside: avoid; }
        .section-title {
          color: var(--primary-color);
          font-size: 18px;
          font-weight: 600;
          border-bottom: 2px solid var(--primary-color);
          padding-bottom: 8px;
          margin-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .grid-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          align-items: flex-start;
        }

        /* --- Content Blocks --- */
        .params-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }
        .param-item {
          background-color: #fdfdfd;
          padding: 8px 12px;
          border-radius: 6px;
          border: 1px solid var(--border-color);
          border-left: 4px solid var(--primary-color);
        }
        .param-item .label { font-size: 12px; font-weight: 600; color: var(--text-light); margin-bottom: 3px; }
        .param-item .value { font-size: 14px; font-weight: 600; color: var(--primary-color); }
        
        .chart-container {
          text-align: center;
          padding: 15px;
          border: 1px  #fff;
          border-radius: 8px;
          background:  #fff;
          page-break-inside: avoid;
        }
        .chart-image { max-width: 100%; height: auto; border-radius: 4px; }
        .chart-title { font-weight: 700; font-size: 14px; margin-top: 15px; color: var(--primary-color); }

        .savings, .cost-analysis {
            padding: 16px 20px;
            border-radius: 8px;
            margin: 15px 0;
            border-width: 1px;
            border-style: solid;
        }
        .savings h3, .cost-analysis h3 { font-size: 16px; margin-top: 0; margin-bottom: 5px; }
        .savings p, .cost-analysis p { font-size: 14px; margin: 0; }
        .savings { background-color: #d4edda; border-color: #28a745; color: #155724; }
        .cost-analysis { background-color: #e8f5e9; border-color: #96b398; color: #1a3d1d; }

        /* --- Tables --- */
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
        }
        th, td {
          padding: 10px;
          text-align: left;
          border-bottom: 1px solid var(--border-color);
          vertical-align: middle;
        }
        th {
          background-color: var(--bg-soft);
          font-weight: 600;
          color: var(--text-dark);
          font-size: 11px;
          text-transform: uppercase;
        }
        tbody tr:nth-child(even) { background-color: #fdfdfd; }
        tbody tr:hover { background-color: #e9ecef; }
        .total-row td { font-weight: 700; background-color: #e8f5e9; border-top: 2px solid var(--primary-color); }
        .accurafil-row td { font-weight: 700; color: var(--primary-color); background-color: #e6f6e9; }
        td.currency, th.currency { text-align: right; }

        /* --- Notes & Disclaimer --- */
        .notes, .disclaimer {
            font-size: 10px;
            color: var(--text-light);
            background-color: var(--bg-soft);
            padding: 15px;
            border-radius: 8px;
            margin-top: 15px;
            border: 1px solid var(--border-color);
        }
        .notes h4, .disclaimer h4 {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
            margin: 0 0 10px 0;
        }
        .notes ul, .disclaimer ul { padding-left: 20px; margin: 0; }
        .notes li, .disclaimer li { margin-bottom: 8px; line-height: 1.3; }

        /* --- Print Controls --- */
        .print-controls {
            position: fixed; top: 20px; right: 20px;
            background: #fff; padding: 10px; border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 1000;
        }
        .print-button {
          background: var(--primary-color); color: white; border: none;
          padding: 12px 24px; font-size: 16px; font-weight: 600;
          border-radius: 5px; cursor: pointer; transition: background-color 0.3s ease;
        }
        .print-button:hover { background-color: #004d2a; }

        @media print {
          .print-controls { display: none; }
          .report-container { padding: 0; }
          body { margin: 1.5cm; }
          .footer { position: static; padding: 15px 0 0 0; margin-top: 20px; }
        }
      </style>
    </head>
    <body>
      <div class="print-controls">
        <button class="print-button" onclick="window.print()">🖨️ Print or Save PDF</button>
      </div>

      <div class="report-container">
        <header class="header">
            <div>
                <img src="https://cdn.shopify.com/s/files/1/0716/7767/3780/files/00-AccuraFil-Logo-2-Transparent.png?v=1757768996" alt="AccuraFil Logo" class="logo">
                <h1>Life-Cycle Cost Analysis Report</h1>
                <p class="subtitle">Total Cost of Ownership for Air Filters</p>
                <div class="date">Generated on: ${dateString}</div>
            </div>
        </header>

         <div class="contact-info">
            <strong>AccuraFil, Inc</strong>
            | 🌐: www.accurafil.com | ✉️: info@accurafil.com | 📞: 540-520-4980 
        </div>

        <main>
            <section class="section">
                <h2 class="section-title">📊 System Parameters</h2>
                <div class="params-grid">
                    ${Object.entries(systemParams).map(([key, value]) => {
                        const labels = {
                            numFilters: 'Number of Filters',
                            airflowRate: 'Airflow Rate (CFM)',
                            operationHours: 'Annual Operation (Hours)',
                            energyCost: 'Energy Cost ($/kWh)',
                            laborCost: 'Labor Cost per Change ($)',
                            disposalCost: 'Disposal Cost per Filter ($)',
                            fanEfficiency: 'Fan Efficiency (%)',
                            analysisPeriod: 'Analysis Period (Years)'
                        };
                        return `<div class="param-item">
                            <div class="label">${labels[key] || key}</div>
                            <div class="value">${value}</div>
                        </div>`;
                    }).join('')}
                </div>
            </section>

            <section class="section">
                <h2 class="section-title">🎯 AccuraFil Filter LCC Cost Analysis</h2>
                 <div class="grid-container">
                     <div>
                        <h3>💰 Detailed LCC Analysis</h3>
                        <table>
                          <thead>
                            <tr>
                              <th>Cost Category</th>
                              <th class="currency">Cost per Filter/Year</th>
                              <th class="currency">Annual Cost for AHU</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Filter Purchase Cost</td>
                              <td class="currency">${formatCurrency(accurafil.filterCostPerFilterPerYear)}</td>
                              <td class="currency">${formatCurrency(accurafil.filterCostPerFilterPerYear * accurafil.numFilters)}</td>
                            </tr>
                            <tr>
                              <td>Energy Cost</td>
                              <td class="currency">${formatCurrency(accurafil.energyCostPerFilterPerYear)}</td>
                              <td class="currency">${formatCurrency(accurafil.energyCostPerFilterPerYear * accurafil.numFilters)}</td>
                            </tr>
                            <tr>
                              <td>Labor & Disposal Cost</td>
                              <td class="currency">${formatCurrency(accurafil.laborDisposalCostPerFilterPerYear)}</td>
                              <td class="currency">${formatCurrency(accurafil.laborDisposalCostPerFilterPerYear * accurafil.numFilters)}</td>
                            </tr>
                            <tr class="total-row">
                              <td>Total Life-Cycle Cost</td>
                              <td class="currency">${formatCurrency(accurafil.totalCostPerFilterPerYear)}</td>
                              <td class="currency">${formatCurrency(accurafil.totalCostPerAHUPerYear)}</td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                    ${pieChartImage ? `
                    <div class="chart-container">
                        <img src="${pieChartImage}" alt="AccuraFil LCC Cost Breakdown - 3D Pie Chart" class="chart-image">
                        <p class="chart-title">AccuraFil Filter LCC Analysis</p>
                    </div>` : '<div></div>'}
                </div>
            </section>
            
            ${(competitors && competitors.filter(c => c).length > 0) ? `
            <section class="section">
                <h2 class="section-title">⚖️ Competitive Analysis</h2>
                ${comparisonChartImage ? `
                    <div class="chart-container" style="margin-bottom: 25px;">
                        <img src="${comparisonChartImage}" alt="Life-Cycle Cost Comparison Chart" class="chart-image">
                        <p class="chart-title">Life-Cycle Cost Comparison by Category</p>
                    </div>` : ''}

                <h3>📊 Detailed LCC Comparison</h3>
                <table>
                  <thead>
                    <tr>
                      <th>Filter Model</th>
                      <th class="currency">Filter Price</th>
                      <th class="currency">Changes/Yr</th>
                      <th class="currency">Avg. &Delta;p</th>
                      <th class="currency">Total LCC for AHU</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="accurafil-row">
                      <td>${accurafil.filterModel}</td>
                      <td class="currency">${formatCurrency(accurafil.filterPrice)}</td>
                      <td class="currency">${formatNumber(accurafil.changesPerYear)}</td>
                      <td class="currency">${formatNumber(accurafil.averagePressureDrop)}</td>
                      <td class="currency">${formatCurrency(accurafil.totalCostPerAHUPerYear)}</td>
                    </tr>
                    ${competitors.filter(c => c).map(competitor => `
                    <tr>
                      <td>${competitor.filterModel}</td>
                      <td class="currency">${formatCurrency(competitor.filterPrice)}</td>
                      <td class="currency">${formatNumber(competitor.changesPerYear)}</td>
                      <td class="currency">${formatNumber(competitor.averagePressureDrop)}</td>
                      <td class="currency">${formatCurrency(competitor.totalCostPerAHUPerYear)}</td>
                    </tr>`).join('')}
                  </tbody>
                </table>
                
                <h3>💰 Cost Savings Summary</h3>
                ${(savingsAmount > 0) ? `
                  <div class="savings">
                    <h3>Potential Savings with AccuraFil</h3>
                    <p>Using AccuraFil filters can save you <strong>${formatCurrency(savingsAmount)}</strong> per year (<strong>${formatNumber(savingsPercent, 1)}% savings</strong>) compared to ${lowestCostCompetitor.filterModel}.</p>
                  </div>` : `
                  <div class="cost-analysis">
                    <h3>Cost Analysis with AccuraFil</h3>
                    <p>AccuraFil costs <strong>${formatCurrency(Math.abs(savingsAmount))}</strong> more per year than ${lowestCostCompetitor.filterModel}, but may provide better performance and long-term value.</p>
                  </div>`}
            </section>` : ''}
            
            <section class="section">
                 <div class="grid-container">
                    <div class="notes">
                      <h4>📝 Calculation Methodology</h4>
                      <ul>
                        <li><strong>Total LCC</strong> = [(Filter Price × Changes) + Energy Cost + Labor & Waste] × Number of Filters</li>
                        <li><strong>Energy Cost</strong> = Derived from Resistance (Δp), Airflow, and Operating Time.</li>
                        <li><strong>Changes per Year</strong> = 12 months ÷ Filter Lifespan (months)</li>
                      </ul>
                    </div>
                     <div class="notes">
                      <h4>💡 Analysis Notes</h4>
                      <ul>
                        <li>This analysis is based on the parameters and specifications provided.</li>
                        <li>All costs are annualized for easy comparison and budgeting.</li>
                        <li>Actual performance may vary based on specific operating conditions.</li>
                      </ul>
                    </div>
                </div>
            </section>
            
            <section class="section">
                <div class="disclaimer">
                    <h4>⚠️ Disclaimers and Terms of Use</h4>
                    <ul>
          <li><strong>Accuracy of Information:</strong> The calculations and results provided by this LCC Calculator are based on the input parameters and assumptions specified by the user. AccuraFil Corporation makes no warranties regarding the accuracy, completeness, or reliability of the results.</li>
          <li><strong>Estimation Purpose:</strong> This tool is designed for estimation purposes only and should not be considered as a guarantee of actual performance or costs. Actual results may vary significantly based on real-world operating conditions, maintenance practices, and other factors.</li>
          <li><strong>Professional Consultation:</strong> For critical applications or significant investments, we recommend consulting with qualified HVAC professionals and conducting detailed site-specific analyses.</li>
          <li><strong>Competitor Data:</strong> Any competitor data used in this analysis has been provided by the user. AccuraFil Corporation does not verify or endorse the accuracy of competitor product specifications or performance claims.</li>
          <li><strong>Limitation of Liability:</strong> AccuraFil Corporation shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from the use of this calculator or reliance on its results.</li>
          <li><strong>Updates and Changes:</strong> AccuraFil Corporation reserves the right to modify or update this calculator and its methodologies at any time without prior notice.</li>
          <li><strong>Intellectual Property:</strong> This calculator and its underlying methodologies are proprietary to AccuraFil Corporation. Unauthorized reproduction or distribution is prohibited.</li>
                   </ul>
                </div>
            </section>
        </main>
      </div>
      <footer class="footer">
        <strong>AccuraFil Corporation</strong> | Phone: 540-520-4980 | Email: <a href="mailto:info@accurafil.com">info@accurafil.com</a> | <a href="https://www.accurafil.com" target="_blank">www.accurafil.com</a>
        <br>&copy; ${new Date().getFullYear()} AccuraFil Corporation. All rights reserved.
      </footer>
    </body>
    </html>
  `;
  
  // Write the complete HTML content to the new window
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  
  // Focus the window to prepare for printing
  printWindow.focus();
  console.log('Professional PDF report generated successfully.');
}
